import BaseCell from '@tcs/client-portal-common/components/molecules/Table/cells/BaseCell';
interface CellProps {
  value: number;
}

const QuarterCell = ({ value }: CellProps) => {
  const date = new Date(value);
  const quarterNames = [
    'January - March',
    'April - June',
    'July - September',
    'October - December',
  ];

  function getQuarter(date: Date) {
    return Math.floor(date.getMonth() / 3);
  }

  const quarter = getQuarter(date);
  const year = date.getFullYear();
  const quarterMonthNames = quarterNames[quarter];
  const quarterName = 'Q' + (quarter + 1);

  const formattedContent =
    quarterName === 'Q4'
      ? `${year}: Annual Statement`
      : `${quarterName} ${year}: ${quarterMonthNames}`;

  return <BaseCell value={formattedContent} />;
};

export default QuarterCell;
